module.exports = __webpack_public_path__ + "static/media/wizualizacja-108.a8b63ff6.png";